module.exports = __webpack_public_path__ + "img/Index_top_bg.264fff89.png";